import { render, staticRenderFns } from "./ProductWrap.vue?vue&type=template&id=047ddbc5&"
import script from "./ProductWrap.vue?vue&type=script&lang=ts&"
export * from "./ProductWrap.vue?vue&type=script&lang=ts&"
import style0 from "shared/components/Product/Item/ProductItem.style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports